import { MenuTypes } from '@ori-events/toggle-menu-flyout';
import { useEffect } from 'react';

import { dispatchToggleMenu } from '~/helpers';

export const useClickSignInButtonSupportCenter = (activeMenu: MenuTypes | '') => {
  const LOGIN_BUTTON_SELECTOR = '.support-center-footer-login__button';

  useEffect(() => {
    const loginButton = document.querySelector(LOGIN_BUTTON_SELECTOR);
    loginButton?.addEventListener('click', (e) => {
      e.preventDefault();

      return dispatchToggleMenu(MenuTypes.AccountSideMenu, activeMenu);
    });

    return () =>
      loginButton?.removeEventListener('click', () =>
        dispatchToggleMenu(MenuTypes.AccountSideMenu, activeMenu),
      );
  }, [activeMenu]);
};
